import { Box } from "@mui/material";
import styled from "styled-components";

export const ContainerSwitch = styled(Box as any)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 50px;
`;
